import React from 'react'
import ProjectLayout from '../../../../../layout/components/ProjectLayout'
import { useParams } from 'react-router-dom'
import ProjectTeam from '../components/ProjectTeam';
import ProjectNotes from '../components/ProjectNotes';
import ProjectContributorBadge from '../components/ProjectContributorBadge';

function ProjectDetailsPage() {
    const {id} = useParams();
    return (
        <ProjectLayout>
            <div className='row'>
                <div className='col-md-9'></div>
                <div className='col-md-3'>
                    <div className=''>
                    <ProjectNotes projectId={id}/>
                    </div>
                    <div className='mt-3'>
                        <ProjectContributorBadge projectId={id} />
                    </div>
                </div>
                
            </div>
        </ProjectLayout>
    )
}

export default ProjectDetailsPage